import React, { useState } from 'react';
import './css/login.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import Footer from './footer';
import Med_Logo from './medeuon_icon';

const Icon = () => {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
  
    const handleSubmit = async (e) => {
      e.preventDefault();

      try {
        //http://localhost/PROJECT/REACT/lms/src/api/login.php
        //./api/login.php
        const res = await fetch('./api/login.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username, password }),
        });
    
        const data = await res.json();
    
        if (data.status) {
          if (data.usertype === 'sunpharma') {
            sessionStorage.setItem('com_id', data.com_id);
            sessionStorage.setItem('com_logo', data.com_logo);
            sessionStorage.setItem('user_type', data.usertype);

            //alert
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Login successfully !",
              showConfirmButton: false,
              timer: 2000
            }).then(() =>{
              navigate('/event');
            })

          } else if (data.usertype === 'medeuon') {
            sessionStorage.setItem('com_id', data.com_id);
            sessionStorage.setItem('com_logo', data.com_logo);
            sessionStorage.setItem('user_type', data.usertype);
            //alert
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Login successfully !",
              showConfirmButton: false,
              timer: 1500
            }).then(() =>{
              navigate('/event');
            })
          }
          }
          
          else {
            Swal.fire({
              icon: 'warning',
              title: 'Error',
              text: data.message,
            });
          }
    
      } catch (error) {
        alert("Login failed.");
        // console.error("Error during login:", error);
      }
    };
    
  
  return (
    <>
       <Med_Logo/>
      <main className="login-wrapper">
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login_icon">
            <FontAwesomeIcon icon={faUser} style={{ color: "#127aca" }} />
          </div>

          <h2>Login</h2>

          <div className="form-group">
            <label>Username</label>
            <div className="user-wrapper">
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Enter your username"
              />
            </div>
          </div>

          <div className="form-group password-group">
            <label>Password</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
              />
              <span
                className="toggle-password"
                onClick={() => setShowPassword(prev => !prev)}
              >
                {showPassword ? 'Hide' : 'Show'}
              </span>
            </div>
          </div>

          <button type="submit" className="login-button">Login</button>
          
        </form>
      </main>
      <Footer/>
     
      </>
  );
};

export default Icon;
